import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupportIntegrationComponent } from './support-integration.component';

const routes: Routes = [
  {
    path: '',
    component: SupportIntegrationComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('@pics-module/support-integration').then(m => m.CardiSupportIntegrationModule),
      },
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportIntegrationRoutingModule {}
